export const iconEdit = () => ({
    height: '1.25rem',
});
